import { NeoModel, ValueObject } from "@singularsystems/neo-core";

@NeoModel
export default class ColumnConfigurationSearchCriteria extends ValueObject {
    
    public searchCriteria: string = "";

    public staticFileSpecID: number | null = null;

    public fileTypeConcatenated: string | null = null;
}